import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20orange%20and%20dark%20geometric%20processor%20chip%20architecture%20pattern%2C%20minimalist%20tech%20aesthetic%2C%20clean%20dark%20background%20with%20subtle%20warm%20glowing%20lines%2C%20futuristic%20semiconductor%20design%20concept%2C%20nodes%20and%20connections%20forming%20a%20network%20on%20chip%20visualization%2C%20no%20text%2C%20professional%20quality&width=1800&height=900&seq=hero-bg-2048&orientation=landscape"
        alt="2048核处理器架构可视化"
        title="2048核处理器 - 极致并行算力架构"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-6">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-flashlight-fill text-sm"></i>
            </div>
            2026年最新技术白皮书已发布
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
            2048核处理器解析
            <br />
            <span className="text-primary-400">极致并行算力的终极形态</span>
          </h1>

          <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto mb-8 leading-relaxed">
            深入解析2048核处理器的技术架构、应用场景与性能优势。无论是AI训练、科学计算还是数据中心部署，
            2048核方案带来前所未有的并行算力突破，助力企业抢占计算制高点。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/categories"
              className="px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md text-sm transition-colors whitespace-nowrap"
            >
              浏览技术文章
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-7 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium rounded-md text-sm backdrop-blur-sm transition-colors whitespace-nowrap"
            >
              了解我们
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-8 text-background-50/40 text-xs">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-cpu-line text-primary-400"></i>
            </div>
            <span>2048 核心</span>
          </div>
          <div className="w-px h-4 bg-background-50/20"></div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-speed-up-fill text-primary-400"></i>
            </div>
            <span>PetaFLOPS 算力</span>
          </div>
          <div className="w-px h-4 bg-background-50/20"></div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shield-flash-fill text-primary-400"></i>
            </div>
            <span>硬件级安全</span>
          </div>
        </div>
      </div>
    </section>
  );
}